var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { attrs: { id: "content" } },
    [
      _c(
        "nav",
        {
          staticClass: "row fixed-top navbar d-md-none d-flex",
          class: { "mt-5": !_vm.EMAIL_VERIFIED },
          attrs: { id: "mobile-topbar", "aria-label": "mobile-nav" },
        },
        [
          _c("b-col", { staticClass: "d-md-none", attrs: { cols: "3" } }, [
            _c(
              "button",
              {
                staticClass: "navbar-toggler",
                attrs: {
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target": "#sidebar",
                  "aria-controls": "sidebar",
                  "aria-expanded": "false",
                  "aria-label": "Toggle navigation",
                },
              },
              [_c("span", { staticClass: "fa fa-bars fa-1x" })]
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-center",
              attrs: { cols: "6", md: "4" },
            },
            [
              _c(
                "div",
                { staticClass: "logo" },
                [
                  _c("router-link", { attrs: { to: "/dashboard" } }, [
                    _c("img", {
                      staticClass: "logo-img",
                      attrs: {
                        alt: _vm.$t("global.words.filogixLogo"),
                        src: _vm.$options.filters.getLogo(),
                      },
                    }),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "side-left fixed-left navbar-collapse collapse",
          attrs: { id: "sidebar", "aria-label": "nav" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "sidebar-logo clear-fix w-100 d-md-flex d-none justify-content-center my-2 py-2 px-4-5",
            },
            [
              _c(
                "div",
                { staticClass: "logo" },
                [
                  _c("router-link", { attrs: { to: "/dashboard" } }, [
                    _c("img", {
                      staticClass: "logo-img",
                      attrs: {
                        alt: _vm.$t("global.words.filogixLogo"),
                        src: _vm.$options.filters.getLogo(),
                      },
                    }),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "sidebar-header sidebar-row align-items-center w-100 mt-md-3 mb-2 px-4-5",
            },
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center flex-column sidebar-columns",
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "profile-avatar",
                    _vm._b(
                      {
                        staticClass: "profilepic-options mr-0 mb-3 profilepic",
                      },
                      "profile-avatar",
                      Object.assign({}, _vm.userDetails),
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "p-0 sidebar-columns", attrs: { cols: "12" } },
                [
                  _c(
                    "h5",
                    {
                      staticClass: "text-center m-0 sidebar-user-name",
                      attrs: { id: "sidebar-name-container" },
                    },
                    [
                      _c(
                        "span",
                        {
                          ref: "fullNameSpan",
                          style: "font-size: " + _vm.fontSizeFullName,
                          attrs: { title: _vm.fullName },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("nameFormat")(
                                  _vm.userDetails.givenName,
                                  _vm.userDetails.familyName
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h6",
                    {
                      staticClass:
                        "text-center text-light-gray bold font-sm mt-1 mb-0",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "text-capitalize account-type" },
                        [_vm._v(_vm._s(_vm.accountTypeTitle))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.selectedApplicationId
                    ? _c(
                        "h6",
                        {
                          staticClass:
                            "text-center text-light-gray bold font-sm mt-1 mb-0",
                        },
                        [
                          _c("span", { staticClass: "text-capitalize" }, [
                            _vm._v(_vm._s(_vm.$t("global.doorr.appId")) + ":"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "text-capitalize account-app-id" },
                            [_vm._v(_vm._s(_vm.selectedApplicationId))]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-body mt-4" }, [
            _c(
              "ul",
              [
                _vm._l(_vm.filteredMenu, function (section, idx) {
                  return [
                    _c("li", { key: idx }, [
                      _c(
                        "p",
                        {
                          staticClass: "sidetab-section text-capitalize mb-0",
                          class: idx === 0 ? "mt-0" : "mt-4",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(section.name) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(section.tabs, function (tab) {
                      return _c(
                        "li",
                        { key: tab.route },
                        [
                          tab.type === "link"
                            ? _c(
                                "a",
                                {
                                  staticClass: "sidetab m-0",
                                  attrs: { href: tab.route, target: "_blank" },
                                },
                                [_vm._v(_vm._s(tab.name))]
                              )
                            : _c(
                                "router-link",
                                {
                                  staticClass: "sidetab m-0",
                                  attrs: {
                                    id: _vm.getTabId(tab.name),
                                    to: _vm.getTabRoute(
                                      section.route,
                                      tab.route
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(tab.name) +
                                      "\n\n              "
                                  ),
                                  tab.name === "Documents" &&
                                  _vm.outstandingClassifications
                                    ? _c(
                                        "span",
                                        {
                                          attrs: {
                                            title: _vm.$t(
                                              "documents.outstandingRequestedDocuments"
                                            ),
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "attention-icon",
                                            staticStyle: {
                                              width: "16px",
                                              height: "16px",
                                              "margin-left": "5px",
                                              "margin-bottom": "4px",
                                            },
                                            attrs: {
                                              alt: _vm.$t(
                                                "global.words.attention"
                                              ),
                                              src: require("@Shared/@Assets/img/attention-icon.png"),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                        ],
                        1
                      )
                    }),
                  ]
                }),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mt-4 btn btn-primary btn-sm clickable",
                        attrs: { id: "new-app-btn" },
                        on: { click: _vm.handleNewAppModal },
                      },
                      [
                        _vm._v(
                          "\n            + " +
                            _vm._s(
                              _vm.$t("application.actions.addNewApplication")
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sidebar-footer d-flex align-items-center justify-content-between text-gray",
            },
            [
              _c(
                "a",
                {
                  staticClass: "logout-btn m-0 clickable",
                  on: { click: _vm.handleLogout },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-sign-out fa-rotate-180",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("global.words.logout")) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("new-app-modal", { ref: "addNewApp" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }